import React, { Fragment } from 'react'

import { Dialog, Transition } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

import { CollapsibleSidebar } from '@/components/common/Sidebar/CollapsibleSidebar'
import PageSidebar, {
  type PageSidebarOption,
  type PageSidebarProps,
} from '@/components/common/Sidebar/PageSidebar'
import { useSidebar } from '@/components/common/Sidebar/hooks'

import { useSidebarStore } from '@/stores/SidebarStore'

const Sidebar: React.FC = () => {
  const { visible, toggleSidebar } = useSidebarStore()
  const { initialFocusRef } = useSidebar()

  return (
    <>
      <Transition.Root show={visible} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20"
          onClose={() => {}}
          initialFocus={initialFocusRef}
        >
          {/*
            this needs to be inside the dialog in order to prevent the headlessui <FocusTrap />
            from bugging out and preventing focus events within the modal
          */}
          <Dialog.Overlay
            className={twMerge(
              'fixed transition-opacity duration-300 inset-0 bg-black',
              visible ? 'opacity-50' : 'opacity-0',
            )}
            onClick={toggleSidebar}
          />
          <div className="fixed overflow-hidden">
            <div className="absolute left-0 inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 flex max-w-80">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-300"
                  enterFrom="-translate-x-full"
                  enterTo="-translate-x-0"
                  leave="transform transition ease-in-out duration-300"
                  leaveFrom="-translate-x-0"
                  leaveTo="-translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-[272px] bg-white dark:bg-primary-900">
                    <CollapsibleSidebar expanded={true} />
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export { PageSidebar, PageSidebarProps, PageSidebarOption }

export default Sidebar
